(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('callInfo', ['$interval', '$timeout', '$compile', 'CallsService', 'WebsocketService', 'WebsocketRegisterType', 'CallPhoneStatus', CallInfoDirectiveFn]);

    /* call-information directive */
    function CallInfoDirectiveFn($interval, $timeout, $compile, CallsService, WebsocketService, WebsocketRegisterType, CallPhoneStatus) {
        var directive = {
            link: link,
            restrict: 'A',
            templateUrl: '/app/ringfoon/templates/call-info.template.html',
            scope: {
            }
        };
        return directive;

        function link(scope, element) {
            // call data
            scope.call = CallsService.call;
            // timespan for wrap-up
            scope.timespan = 0;
            // interval and timeouter
            var interval = null;
            var timeouter = null;
            // talking element
            var talking = null;

            // websocket subscriber
            var 
                ws1, ws2, ws3, ws4;

            activate();

            // activate directive
            function activate() {

                // phone status has changed (CONNECTED or IDLE or RINGING)
                ws1 = WebsocketService.register(WebsocketRegisterType.PhoneStatus, function (jObject) {

                    /// Data-Structor To Send
                    ///     type => Type Of WebSocket-Call
                    ///     info => PhoneStatus (CONNECTED, IDLE)

                    CallsService.phoneStatus(jObject);
                    scope.$evalAsync();

                    // remove before
                    if (talking) {
                        talking.remove();
                    } // if


                    // On "CONNECTED" -> TALKING
                    if (scope.call.phoneStatus === CallPhoneStatus.CONNECTED) {
                        // make directive
                        talking = $compile('<talking class="flex-item-centered"></talking>')(scope);
                        element.append(talking);

                        element.css({ "display": "inline-flex" });

                    } // if   

                });

                // ivr is sending the "wrap-up-starts"- event -> show progress-bar for wrap-up
                ws2 = WebsocketService.register(WebsocketRegisterType.OnWrapUpStart, function (jObject) {
                    /// Data-Structor To Send
                    ///     type => Type Of WebSocket-Call
                    ///     info => ContactId
                    ///     data => WrapUpTime (max)

                    // is the guid the same of the current call ?
                    if (scope.call.with.data.contact.guid !== jObject.info) { return; }
                    // start wrap up 
                    timeouter = $timeout(function () {
                        CallsService.closeModal();
                        scope.call.wrapUp.start = true;
                        scope.call.wrapUp.time = jObject.data;

                        // start interval
                        start();
                    });

                });

                // ivr is sending the "wrap-up-pause"- event
                ws3 = WebsocketService.register(WebsocketRegisterType.OnWrapUpPause, function (jObject) {

                    /// Data-Structor To Send
                    ///     type => Type Of WebSocket-Call
                    ///     info => ContactId

                    // is the guid the same of the current call ?
                    if (scope.call.with.data.contact.guid !== jObject.info) { return; }
                    // pause wrap up (stop the interval)
                    pause();
                });

                // ivr is sending the "wrap-up-stop"- event
                ws4 = WebsocketService.register(WebsocketRegisterType.OnWrapUpStop, function (jObject) {

                    /// Data-Structor To Send
                    ///     type => Type Of WebSocket-Call
                    ///     info => ContactId

                    // is the guid the same of the current call ?
                    if (scope.call.with.data.contact.guid !== jObject.info) { return; }
                    // end wrap up 
                    stop();
                });

            } // activate

            // stop the wrap up and hide the call-information
            function stop() {
                pause();
                timeouter = $timeout(function () {
                    interval = null;
                    scope.timespan = 0;
                    scope.call.wrapUp.start = false;
                    scope.call.wrapUp.time = null;
                    element.css({ "display": "none" });
                }, 0);
            }

            // end call
            scope.hangUp = function () {
                CallsService.decline();
                // begin timing
                scope.timespan = 0;
            };

            // pause the wrap-up
            scope.pauseWrapUp = function () {
                CallsService.pauseWrapUp();
            };

            // stop the wrap-up
            scope.stopWrapUp = function () {
                CallsService.stopWrapUp();
            };

            // start intervall for wrap-up-progress
            function start() {
                scope.timespan = 0;
                // stop if some interval exists
                pause();
                // interval
                interval = $interval(function () {
                    if (scope.call.wrapUp.time === scope.timespan.toString()) {
                        stop();
                        return;
                    }
                    scope.timespan++;
                }, 1000);
            }

            // stop intervall
            function pause() {
                $interval.cancel(interval);
            }

            // on destroy
            scope.$on("$destroy", function () {
                $interval.cancel(interval);
                interval = null;
                $timeout.cancel(timeouter);
                timeouter = null;
                scope.timespan = null;

                if (ws1) { WebsocketService.unregister(ws1.id); }
                if (ws2) { WebsocketService.unregister(ws2.id); }
                if (ws3) { WebsocketService.unregister(ws3.id); }
                if (ws4) { WebsocketService.unregister(ws4.id); }
            });

        } // link
    }
})();